export const PROJECT_STATE = {
  FILL_THE_FORM: 0,
  GENERATING_NARRATIVES: 1,
  GENERATING_SCRIPT: 2,
  NARRATIVES_EDITING: 3,
  ASSISTANT_REQUEST: 4,
};

export const RECORD_PERMISSION = {
  CLIP_ONLY: {
    TERM: 'storyboard.editor.invite_modal.record_permission.one',
    TYPE: false,
  },
  ALL_CLIPS: {
    TERM: 'storyboard.editor.invite_modal.record_permission.all',
    TYPE: true,
  },
};

export const CLIP_STATUS = {
  NOT_ASSIGNED: {
    TERM: '',
    TYPE: 0,
  },
  NOT_RESPONDED: {
    TERM: 'storyboard.editor.clip_status.not_responded',
    TYPE: 1,
  },
  PENDING: {
    TERM: 'storyboard.editor.clip_status.pending',
    TYPE: 2,
  },
  RECORDED: {
    TERM: 'storyboard.editor.clip_status.video_recorded',
    TYPE: 3,
  },
};

export const ORIENTATIONS = {
  LANDSCAPE: {
    type: 'landscape',
    text: 'storyboard.generating.orientation.landscape',
  },
  SQUARE: {
    type: 'square',
    text: 'storyboard.generating.orientation.square',
  },
  PORTRAIT: {
    type: 'portrait',
    text: 'storyboard.generating.orientation.portrait',
  },
};

export const LANGUAGES = {
  ENGLISH: {
    id: 'en',
    type: 'en',
    name: 'storyboard.generating.en_language',
    src: 'english',
  },
  NEDERLANDS: {
    id: 'nl',
    type: 'nl',
    name: 'storyboard.generating.nl_language',
    src: 'dutch',
  },
};

export const VOICE_TONES = {
  CASUAL: {
    type: 'casual',
    text: 'storyboard.generating.voice_tones.casual',
  },
  FORMAT: {
    type: 'formal',
    text: 'storyboard.generating.voice_tones.formal',
  },
  INSPIRING: {
    type: 'inspiring',
    text: 'storyboard.generating.voice_tones.inspiring',
  },
  Convincing: {
    type: 'convincing',
    text: 'storyboard.generating.voice_tones.convincing',
  },
};

export const NUMBERS_OF_ACTORS = {
  ONE: {
    type: 1,
    name: 'storyboard.generating.number_of_actors.one',
  },
  TWO: {
    type: 2,
    name: 'storyboard.generating.number_of_actors.two',
  },
  THREE: {
    type: 3,
    name: 'storyboard.generating.number_of_actors.three',
  },
};

export const PARTICIPANTS = {
  ME: {
    type: 'me',
    name: 'storyboard.generating.participants.me',
  },
  ME_AND_OTHERS: {
    type: 'me_and_others',
    name: 'storyboard.generating.participants.me_and_others',
  },
  OTHERS: {
    type: 'others',
    name: 'storyboard.generating.participants.others',
  },
};
